var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'flex items-center gap-2 pl-2 pr-4 py-1.5 rounded-full transition-all md:ml-2 group',
    _vm.isSolid
      ? 'bg-gray-100 hover:bg-gray-200 text-gray-900'
      : 'bg-white/20 hover:bg-white/30 backdrop-blur-md text-white',
    _vm.storesCount === 1 ? 'pointer-events-none' : ''
  ],on:{"click":_vm.handleClick}},[_c('div',{class:[
      'p-1.5 rounded-full flex',
      _vm.isSolid
        ? 'bg-white text-primary-600 shadow-sm'
        : 'bg-white/20 text-white'
    ]},[_c('MapPin',{attrs:{"size":16}})],1),_c('div',{staticClass:"flex flex-col items-start text-left mr-1"},[_c('span',{staticClass:"text-xs font-bold leading-tight truncate location-name"},[_vm._v(" "+_vm._s(_vm.locationName || _vm.storeAddress || "Select Location")+" ")]),(_vm.storeAddress && _vm.locationName)?_c('span',{class:[
        'font-medium leading-none truncate',
        _vm.isSolid ? 'text-gray-500' : 'text-white/80'
      ],staticStyle:{"font-size":"10px","max-width":"140px"}},[_vm._v(" "+_vm._s(_vm.storeAddress)+" ")]):_c('span',{class:[
        'font-medium leading-none',
        _vm.isSolid ? 'text-gray-500' : 'text-white/80'
      ],staticStyle:{"font-size":"10px"}},[_vm._v(" "+_vm._s(_vm.storesCount)+" "+_vm._s(_vm.storesCount === 1 ? "location" : "locations")+" available ")])]),(_vm.storesCount > 1)?_c('ChevronDown',{staticClass:"opacity-70 ml-1 group-hover:translate-y-0.5 transition-transform",attrs:{"size":14}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }